import {View} from 'backbone'
import template from 'behaviors/properties/main/message-type.ejs';
import undoService from 'UndoService.js'
import textConstants from "../../../../constants/TextConstants";


class MessageTypeView extends View {
    initialize(opts){
        super.initialize(opts);
        if(!this.model.has('confirmation')){
            this.model.set('confirmation', 'none', {silent:true});
        }
        if(!this.model.has('stopExecution')){
            this.model.set('stopExecution', 'false', {silent:true});
        }
        this.events = {
            'change .changeConfirmation': 'changeConfirmation',
            'change .changeStopExecution': 'changeStopExecution'
        };
        this.listenTo(this.model,'change', this.render);
    }
    changeConfirmation(e){
        const value = e.currentTarget.value;
        const oldValue = this.model.get('confirmation');
        this.model.set('confirmation', value, {silent:true});
        this.render();

        undoService.add({
            undo:() =>{
                this.model.set('confirmation',oldValue,{silent:true});
                this.render();
            },
            redo:() => {
                this.model.set('confirmation',value,{silent:true});
                this.render();
            }
        })
    }
    changeStopExecution(e){
        const target = e.currentTarget;
        const oldValue = this.model.get('stopExecution');
        this.model.set('stopExecution', (target.checked) ? 'true' : 'false', {silent:true});

        undoService.add({
            undo:() =>{
                this.model.set('stopExecution',oldValue,{silent:true});
                this.render();
            },
            redo:() => {
                this.model.set('stopExecution',value,{silent:true});
                this.render();
            }
        },textConstants.UNDO_PROP_CHANGE)
    }
    render(){
        this.$el.html(template(this.model.toJSON()));
        this.delegateEvents();
    }
}

export default MessageTypeView;